import React from 'react';

const RobotPertanianCerdas: React.FC = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        Badan Pusat Statistik 2024 mencatat bahwa 45% petani Indonesia telah mengadopsi teknologi robotika dalam 3 tahun terakhir. Revolusi pertanian 4.0 ini dipelopori oleh robot cerdas yang mampu meningkatkan produktivitas hingga 300% menurut data Kementerian Pertanian.
      </p>

      <h2 className="text-2xl font-bold mb-4">Jenis Robot Pertanian Unggulan</h2>
      
      <h3 className="text-lg font-semibold mb-2">1. Drone Penanam Padi</h3>
      <p className="mb-3">
        Mampu menanam bibit dengan presisi 2cm antar titik. Satu drone dapat menanami 10 hektar per hari.
      </p>

      <h3 className="text-lg font-semibold mb-2">2. Robot Pemantau Tanaman</h3>
      <p className="mb-3">
        Menggunakan AI untuk deteksi hama dan penyakit dengan akurasi 92% berdasarkan uji coba di Subang.
      </p>

      <h3 className="text-lg font-semibold mb-2">3. Autonomous Traktor</h3>
      <p className="mb-3">
        Dapat bekerja 24 jam dengan GPS RTK dan 40% lebih hemat bahan bakar dibanding traktor konvensional.
      </p>

      <h3 className="text-lg font-semibold mb-2">4. Robot Pemanen Buah</h3>
      <p className="mb-3">
        Menggunakan computer vision untuk menentukan kematangan optimal buah dengan teknologi gripper vakum.
      </p>

      <h2 className="text-2xl font-bold mb-4">Teknologi Inti Robot Pertanian</h2>
      <ol className="list-decimal pl-6 mb-6 space-y-2">
        <li>Computer Vision - Analisis kesehatan tanaman dengan kamera multispektral</li>
        <li>IoT Sensors - Memantau kelembaban tanah dan nutrisi secara real-time</li>
        <li>Autonomous Navigation - Sistem SLAM untuk navigasi mandiri</li>
        <li>AI Decision Making - Algoritma prediksi panen berbasis data cuaca</li>
      </ol>

      <h2 className="text-2xl font-bold mb-4">Studi Kasus: AgroBot di Jawa Tengah</h2>
      <p className="mb-2">
        Startup lokal RoboFarm Indonesia mengembangkan robot multifungsi yang dapat:
      </p>
      <ul className="list-disc pl-6 mb-4">
        <li>Menyemprot pestisida dengan presisi</li>
        <li>Memetakan area tanam menggunakan LiDAR</li>
        <li>Bekerja selama 8 jam dengan sekali charge</li>
      </ul>
      <p className="mb-4">
        Hasil uji coba di Boyolali menunjukkan peningkatan hasil panen cabai sebesar 45%.
      </p>

      <h2 className="text-2xl font-bold mb-4">Manfaat Utama</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Operasional 24 jam meningkatkan efisiensi waktu</li>
        <li>Irigasi presisi menghemat penggunaan air</li>
        <li>Dashboard analitik berbasis data</li>
        <li>Mengurangi beban kerja fisik petani</li>
        <li>Ramah lingkungan dengan limbah kimia lebih sedikit</li>
        <li>Return of investment dalam 1 tahun</li>
      </ul>

      <h2 className="text-2xl font-bold mb-4">Tantangan Implementasi</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Biaya awal tinggi (Rp50-200 juta per unit)</li>
        <li>Keterbatasan SDM yang mampu merawat teknologi</li>
        <li>Adaptasi lahan tradisional yang belum terstandardisasi</li>
      </ul>

      <p className="mb-4">
        Pemerintah menyediakan solusi melalui Program KUR Teknologi Pertanian dengan bunga 2% dan pelatihan Smart Farming Bootcamp di 34 provinsi.
      </p>

      <p>
        Untuk informasi lebih lanjut, kunjungi robotikpertanian.id atau hubungi Balai Penyuluhan Pertanian terdekat.
      </p>
    </div>
  );
};

export default RobotPertanianCerdas;